import { api_gateway } from '../../conexoes/api'
import { requestResolver } from '../../utils/requestResolver'

const config = require('../../configuracoes.json')
const { accessKey } = config

const headers = {
  'Content-Type': 'application/json',
  Authorization: accessKey
}

export const UserTrialSimcardsService = {
  //#region POST
  postUser: (data) => {
    return requestResolver(
      api_gateway.post(`/api/v2/exposec/user`, data, {
        headers: headers
      })
    )
  },
  postFormUser: ({ name, phone, email, company }) => {
    const formattedPhone = phone.replace(/\D/g, '')

    return requestResolver(
      api_gateway.post(
        `/api/v2/exposec/contactForms`,
        {
          ds_nome_cliente: name,
          ds_telefone: formattedPhone,
          ds_email: email,
          ds_nome_empresa: company
        },
        {
          headers: headers
        }
      )
    )
  },
  postSendEmail: (id) => {
    return requestResolver(
      api_gateway.post(
        '/api/v2/exposec/firstAccessEmail',
        {
          id
        },
        {
          headers: headers
        }
      )
    )
  }
  //#endregion POST
}
